import { parseBooleanEnabledSOC } from "src/features/kyc/imports/utils";

export const kycSuspendUnderageViewEnabled = parseBooleanEnabledSOC(
  "kyc.suspend.underage.view.enabled",
  "0"
);
